import { getConfig, getRequest, postRequest, getCookie } from "../util";

const BASE_URL = process.env.REACT_APP_BASE_URL || "https://staging.playo.io";
const CONTROLLER_PUBLIC = `${BASE_URL}/controller-public/partner-app`;
const CONTROLLER = `${BASE_URL}/controller/partner-app`;

export default class External {
  static login(data) {
    const url = `${CONTROLLER_PUBLIC}/login`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getDashboardData(data) {
    const url = `${CONTROLLER}/dashboard`;
    const config = getConfig(data);
    return getRequest(url, config);
  }

  static getActivities() {
    const url = `${CONTROLLER}/activities`;
    const config = getConfig();
    return getRequest(url, config);
  }

  static getAvailability(data) {
    const url = `${CONTROLLER}/availability`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getEscalationMatrix() {
    const url = `${CONTROLLER}/escalation-matrix`;
    const config = getConfig();
    return getRequest(url, config);
  }

  static logout(data) {
    const url = `${CONTROLLER}/logout`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static switchClub(data) {
    const url = `${CONTROLLER}/switch/account`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getSlotUnavailabilityStatus(data) {
    const url = `${CONTROLLER}/slots/unavailability/status`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static cancelBooking(data) {
    const url = `${CONTROLLER}/booking/cancellation`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getCountryCodes() {
    const url = `${BASE_URL}/utils/thirdparty/countries`;
    const config = getConfig();
    return getRequest(url, config);
  }

  static getCustomerDetails(data) {
    const url = `${CONTROLLER}/customer/details`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static confirmBooking(data) {
    const url = `${CONTROLLER}/booking`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static confirmBulkBooking(data) {
    const url = `${CONTROLLER}/booking/pattern`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getNotifications(data) {
    const url = `${CONTROLLER}/notifications`;
    const config = getConfig(data);
    return getRequest(url, config);
  }

  static updateBookingAmount(data) {
    const url = `${CONTROLLER}/booking/amount/update`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static sendBookingPaymentLink(data) {
    const url = `${CONTROLLER}/booking/payment/link`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getInTouch(data) {
    const url = `${CONTROLLER}/get-in-touch`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getPriceClassDetails() {
    const url = `${CONTROLLER}/pricing/class/details`;
    const config = getConfig();
    return getRequest(url, config);
  }

  static getPricingDetails(data) {
    const url = `${CONTROLLER}/pricing/config/details`;
    const config = getConfig(data);
    return getRequest(url, config);
  }

  static changeUserPassword(data) {
    const url = `${CONTROLLER}/password/update`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static createUser(data) {
    const url = `${CONTROLLER}/user/create`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static searchBookings(data, type) {
    let bookingTypeUrl =
      type === "bulk" ? "booking/pattern/search" : "booking/search";
    const url = `${CONTROLLER}/${bookingTypeUrl}`;
    const config = getConfig(data);
    return getRequest(url, config);
  }

  static getBookingTransactions(data) {
    const url = `${CONTROLLER}/transactions/details`;
    const config = getConfig(data);
    return getRequest(url, config);
  }

  static downloadBookingReport(data) {
    const url = `${CONTROLLER}/reports/bookings/download`;
    const config = getConfig(data, "blob");

    return getRequest(url, config);
  }

  static downloadCancellationReport(data) {
    const url = `${CONTROLLER}/reports/cancellations/download`;
    const config = getConfig(data, "blob");
    return getRequest(url, config);
  }

  static updateBooking(data) {
    const url = `${CONTROLLER}/booking/payment/update`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static transactionCode() {
    const url = `${CONTROLLER}/transaction/codes`;
    const config = getConfig();
    return getRequest(url, config);
  }

  static rescheduleBookingVerify(data) {
    const url = `${CONTROLLER}/booking/reschedule/verify`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static reschedulePrice(data) {
    const url = `${CONTROLLER}/booking/reschedule/pricing`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static rescheduleBooking(data) {
    const url = `${CONTROLLER}/booking/reschedule`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static printBookingReceipt(data) {
    const url = `${CONTROLLER}/receipt`;
    const config = getConfig(data, "blob");
    return getRequest(url, config);
  }

  static printBookingStatement(data) {
    const url = `${CONTROLLER}/booking/statement`;
    const config = getConfig(data, "blob");
    return getRequest(url, config);
  }

  static getBooking(data) {
    const url = `${CONTROLLER}/booking/details`;
    const config = getConfig(data);
    return getRequest(url, config);
  }

  static getCourtList(data) {
    const url = `${CONTROLLER}/court/details`;
    const config = getConfig(data);
    return getRequest(url, config);
  }

  static verifySlotsAvailability(data) {
    const url = `${CONTROLLER}/slots/availability/verify`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getPatternBookingSlots(data) {
    const url = `${CONTROLLER}/booking/pattern/slots`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static editPrice(data) {
    const url = `${CONTROLLER}/pricing/config`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static oneSignalUpdate(data) {
    const url = `${CONTROLLER}/onesignal/update`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static enableReschedule(data) {
    const url = `${CONTROLLER}/booking/reschedule/enable `;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static markNoShow(data) {
    const url = `${CONTROLLER}/booking/noshow`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static syncAvailability() {
    const url = `${CONTROLLER}/availability/sanity`;
    const config = getConfig();
    return postRequest(url, "", config);
  }

  static bookingCheckIn(data) {
    const url = `${CONTROLLER}/booking/checkin`;
    const config = getConfig();
    return postRequest(url, data, config);
  }

  static getCategoriesList(data) {
    const url = `${CONTROLLER}/event/category`;
    const config = getConfig(data);
    return getRequest(url, config);
  }
  static getEventBookingList(data) {
    const url = `${CONTROLLER}/event/booking/list`;
    const config = getConfig(data);
    return getRequest(url, config);
  }
  static getEvents() {
    const url = `${CONTROLLER}/events`;
    const config = getConfig();
    return getRequest(url, config);
  }
}
